const statusPrettier = status => {
  switch (status) {
    case "SUCCESS":
      return "Completed";
    case "ERROR":
      return "Failed";
    case "NA":
      return "Draft";
    case "INPROGRESS":
      return "In Progress";
    case "QUEUED":
      return "Queued";
    default:
      return status;
  }
};

export default statusPrettier;
